import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'HEBREW_DATE_INPUT', {
  YEAR: 'Year',
  MONTH: 'Month',
  DAY: 'Day',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'HEBREW_DATE_INPUT', {
  YEAR: 'Año',
  MONTH: 'Mes',
  DAY: 'Día',
});
